import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface OperationSectionProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function OperationSection({ onOpenWhatsApp }: OperationSectionProps) {
  const steps = [
    {
      step: '1',
      title: 'İhtiyacınızı Paylaşın',
      description: 'Kişi sayınızı, hizmet türünü ve bölgenizi iletin.',
    },
    {
      step: '2',
      title: 'Size Özel Çözüm Belirleyelim',
      description: 'İşletmenizin ihtiyacına uygun hizmet modeli oluşturulsun.',
    },
    {
      step: '3',
      title: 'Teklifinizi Alın',
      description: 'Size uygun catering teklifini öğrenin.',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-5xl mx-auto text-center">
        <div className="reveal mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
            YEMEK HİZMETİNİZİ PLANLAYALIM
          </h2>
        </div>
        <div className="reveal grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-12">
          {steps.map((item) => (
            <div key={item.step} className="relative">
              <div className="w-16 h-16 md:w-20 md:h-20 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
                <span className="font-heading text-2xl md:text-3xl text-primary-600">
                  {item.step}
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="font-body text-foreground-600 text-sm md:text-base leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
        <div className="reveal">
          <button
            onClick={() => onOpenWhatsApp()}
            className="btn-primary text-base px-10 py-4"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WHATSAPP&apos;TAN HEMEN SOR
          </button>
        </div>
      </div>
    </section>
  );
}